<template>
  <div id="November2024" class="202411 bg-center">
    <div class="fixed z-50 hidden xl:block" :class="{ 'fixed-btn': isMenu, 'hidden-btn': !isMenu}">
      <a class="block px-3">
        <img src="~@/assets/images/202411/menu/menu-off_01.png" class="object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#plan1')">
        <img src="~@/assets/images/202411/menu/menu-off_02.png" class="off object-contain">
        <img src="~@/assets/images/202411/menu/menu-on_02.png" class="on object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#plan2')">
        <img src="~@/assets/images/202411/menu/menu-off_03.png" class="off object-contain">
        <img src="~@/assets/images/202411/menu/menu-on_03.png" class="on object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#November2024')">
        <img src="~@/assets/images/202411/menu/menu-off_04.png" class="off object-contain">
        <img src="~@/assets/images/202411/menu/menu-on_04.png" class="on object-contain">
      </a>
    </div>
    <div class="top py-4">
      <div class="logo py-4">
        <img src="~@/assets/images/202411/LiveABC-logo.png" class="object-contain mx-auto">
      </div>
      <div class="banner">
        <img src="~@/assets/images/202411/master-visaul.png" class="object-contain mx-auto hidden md:block">
        <img src="~@/assets/images/202411/m/master-visaul-mobile.png" class="object-contain mx-auto md:hidden">
      </div>
      <div class="">
        <img src="~@/assets/images/202411/second-title.png" class="object-contain mx-auto hidden md:block">
        <img src="~@/assets/images/202411/m/second-title-mobile.png" class="object-contain mx-auto md:hidden">
      </div>
      <!-- <div class="md:hidden">
        <img src="~@/assets/images/202411/second-title.png" class="object-contain mx-auto">
      </div> -->
    </div>

    <div class="flex justify-center max-w-6xl mx-auto flex-wrap mb-6 md:mb-0">
      <a class="w-full md:w-1/2 p-1 px-3 md:p-3 hover-item cursor-pointer" href="https://liveabc.site/win11" target="_blank">
        <img src="~@/assets/images/202411/plan-a-on.png" class="on object-contain mx-auto">
        <img src="~@/assets/images/202411/plan-a-off.png" class="off object-contain mx-auto">
      </a>
      <a class="w-full md:w-1/2 p-1 px-3 md:p-3 hover-item cursor-pointer" href="https://store.liveabc.com/products/recent/sale?tag=421" target="_blank">
        <img src="~@/assets/images/202411/plan-b-on.png" class="on object-contain mx-auto">
        <img src="~@/assets/images/202411/plan-b-off.png" class="off object-contain mx-auto">
      </a>
    </div>

    <a class="max-w-6xl mx-auto bg-white border-4 rounded-3xl card_outer p-3 mb-16 md:mb-24 block" id="plan1" href="https://liveabc.site/win11" target="_blank">
      <div class="border-b-4 p-4 border-orange">
        <img src="~@/assets/images/202411/plan-a-info-title-01.png" class="object-contain mx-auto hidden md:block">
        <img src="~@/assets/images/202411/m/plan-a-info-title-01-mobile.png" class="object-contain mx-auto md:hidden">
      </div>
      <div class="border-b-4 p-2 lg:p-4 border-orange flex flex-wrap">
        <div class="w-full md:w-1/2 p-3 text-center md:text-xl tracking-wider">
          <p class="text-orange font-semibold">團購秒殺搶購，佳評如潮！</p>
          <p class="mb-1 font-semibold">符合108課綱，科學素養必備！</p>
          <div class="">
            <img src="~@/assets/images/202411/hiw-cover.png" class="object-contain mx-auto">
          </div>
          <div class="lg:flex justify-center mb-4">
            <p class=" font-bold">知識大圖解 <span class="text-xs">國際中文版</span>7期</p>
            <p class="font-bold">＋年度特刊1本</p>
          </div>
          <div class="flex flex-col md:flex-row justify-center">
            <div class="text-lg px-2 flex md:flex-none justify-center mb-2 md:mb-0">
              <p class="text-xl font-semibold">特價<span class="text-orange">1,111</span>元</p>
              <p class="text-lg font-light line-through text-gray-500">原價1,839元</p>
            </div>
            <div class="px-2 w-32 md:ww-auto mx-auto">
              <div>
                <img src="~@/assets/images/202411/order-button.png" class="object-contain mx-auto">
              </div>
            </div>
          </div>
        </div>
        <div class="w-full md:w-1/2 p-3 text-center md:text-xl tracking-wider">
          <p class="text-orange font-semibold">最貼近國中會考的補充教材！</p>
          <p class="mb-1 font-semibold">全民英檢初級、英語入門最佳選擇！</p>
          <div class="">
            <img src="~@/assets/images/202411/abc-cover.png" class="object-contain mx-auto">
          </div>
          <!-- <p class="mb-4 font-bold">ABC互動英語7期＋年度特刊1本</p> -->
          <div class="lg:flex justify-center mb-4">
            <p class=" font-bold">ABC互動英語7期</p>
            <p class="font-bold">＋年度特刊1本</p>
          </div>
          <div class="flex flex-col md:flex-row justify-center">
            <div class="text-lg px-2 flex md:flex-none justify-center mb-2 md:mb-0">
              <p class="text-xl font-semibold">特價<span class="text-orange">1,111</span>元</p>
              <p class="text-lg font-light line-through text-gray-500
              ">原價1,839元</p>
            </div>
            <div class="px-2 w-32 md:ww-auto mx-auto">
              <img src="~@/assets/images/202411/order-button.png" class="object-contain mx-auto">
            </div>
          </div>
        </div>
      </div>
      <div class="md:p-4 flex flex-wrap">
        <div v-for="(item, index) in magData" :key="index" class="w-1/2 md:w-1/4 p-3 text-center md:text-lg tracking-wider" >
          <p class="text-orange font-semibold mb-2 md:mb-4">{{ item.text }}</p>
          <div class="">
            <img :src="item.img_url" class="object-contain mx-auto">
          </div>
          <p class="mb-4 font-bold">{{ item.name }} <span class="text-orange">7</span>期<br/>＋年度特刊1本</p>
            <div class="text-lg px-2 mb-5">
              <p class="md:text-xl font-semibold">特價<span class="text-orange">1,111</span>元</p>
              <p class="text-sm md:text-base font-light line-through text-gray-500">原價1,839元</p>
            </div>
            <div class="px-2 w-32 md:ww-auto mx-auto">
              <img src="~@/assets/images/202411/order-button.png" class="object-contain mx-auto">
            </div>
        </div>
      </div>
    </a>

    <div class="max-w-6xl mx-auto bg-white border-4 rounded-3xl card_outer p-3 mb-16" id="plan2">
      <a class="p-4 block" href="https://store.liveabc.com/products/recent/sale?tag=421" target="_blank">
        <img src="~@/assets/images/202411/plan-b-info-title.png" class="object-contain mx-auto hidden md:block -mt-16">
        <img src="~@/assets/images/202411/m/plan-b-info-title-mobile.png" class="object-contain mx-auto md:hidden">
      </a>
      <a class="p-4 block" href="https://store.liveabc.com/products/recent/sale?tag=421" target="_blank">
        <img src="~@/assets/images/202411/plan-b-other.png" class="object-contain mx-auto hidden md:block">
        <img src="~@/assets/images/202411/m/plan-b-other-mobile.png" class="object-contain mx-auto md:hidden">
      </a>
      <div class="flex flex-wrap">
        <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }" target="_blank" class="item w-1/2 md:w-1/3 p-4 text-center font-semibold tracking-widest" v-for="(item, index) in bookData" :key="index">
          <div class="p-2">
            <img :src="item.img_url" class="object-contain mx-auto">
          </div>
          <p>{{ item.text }}<br/>{{ item.text2 }}</p>
          <p class="">----------------</p>
          <p>特價後<span class="text-orange">{{ item.price }}</span>元</p>
        </router-link>
      </div>
    </div>

    <div class="footer">
      <div class="max-w-5xl text-center mx-auto font-semibold leading-loose mb-10 px-4">
        <p class="text-lg mb-1">注意事項</p>
        <p class="text-sm">活動時間2024.11.1~12.31於LiveABC官方網站下單消費，即可參加抽獎活動，訂單成立並完成付款後即符合抽獎資格，一筆訂單可以參與抽獎一次。將於2025.1.20抽出1名得主，公告於LiveABC官方網站及官方臉書粉絲團。活動期間產生之訂單取消、退貨、交易失敗等條件，將失去參與本活動之資格，不予另行通知。活動內容以LiveABC官網發布為主。本公司保留活動修改、變更之權利。</p>
      </div>
      <router-link :to="{ name: 'index' }" class="block mb-8 md:mb-16 p-2" target="_blank">
        <div class="">
          <img src="~@/assets/images/202411/go-to-liveabc-button.png" class="object-contain mx-auto hidden md:block">
          <img src="~@/assets/images/202411/m/go-to-liveabc-button-mobile.png" class="object-contain mx-auto md:hidden">
        </div>
      </router-link>

      <div class="hidden md:block">
        <img src="~@/assets/images/202411/under-block.png" class="object-contain mx-auto">
      </div>
      <div class="md:hidden">
        <div class="boy">
          <img src="~@/assets/images/202411/m/under-pic.png" class="object-contain mx-auto">
        </div>
        <!-- <img src="~@/assets/images/202411/under-block.png" class="object-contain mx-auto"> -->
      </div>
    </div>
  </div>
</template>
<script>
import jump from 'jump.js'
export default {
  name: 'October2024',
  metaInfo () {
    return {
      title: '下單就抽11111元現金💰 1111購物盛典',
      titleTemplate: null
    }
  },
  data () {
    return {
      isMenu: true,
      magData: [
        { text: '多益雅思補充教材', name: 'CNN互動英語', img_url: require('@/assets/images/202411/cnn-cover.png') },
        { text: '自學日語檢測必看', name: '互動日本語', img_url: require('@/assets/images/202411/jp-cover.png') },
        { text: '高中升學GEPT中級', name: 'Live互動英語', img_url: require('@/assets/images/202411/live-cover.png') },
        { text: '考大學GEPT中高級', name: 'ALL+互動英語', img_url: require('@/assets/images/202411/all-cover.png') }
      ],
      bookData: [
        { id: 7993, text: '跟著粉紅豬小妹', text2: '唱跳學英語', price: '3,150', img_url: require('@/assets/images/202411/suit-01.png') },
        { id: 8728, text: '一看就懂！全彩圖解', text2: '會話輕鬆學', price: '2,890', img_url: require('@/assets/images/202411/suit-02.png') },
        { id: 7796, text: '國小生必看！', text2: '經典暢銷兒童英語', price: '3,400', img_url: require('@/assets/images/202411/suit-03.png') },
        { id: 9622, text: '中小學生英語科', text2: '打基礎必備', price: '3,150', img_url: require('@/assets/images/202411/suit-04.png') },
        { id: 8733, text: 'CNN主播教你', text2: '新聞最常用英語', price: '2,890', img_url: require('@/assets/images/202411/suit-05.png') },
        { id: 8248, text: '出國留遊學必備', text2: '開口不用怕', price: '3,150', img_url: require('@/assets/images/202411/suit-06.png') },
        { id: 7800, text: '金色證書入手', text2: '多益輕鬆拿高分', price: '2,890', img_url: require('@/assets/images/202411/suit-07.png') },
        { id: 7388, text: '和全球做生意', text2: '書信會議都OK', price: '3,150', img_url: require('@/assets/images/202411/suit-08.png') },
        { id: 6565, text: '生活中用到的日語', text2: '輕鬆開口說', price: '3,150', img_url: require('@/assets/images/202411/suit-09.png') },
        { id: 6568, text: '雅思檢定官方指南', text2: '不高分也難', price: '3,150', img_url: require('@/assets/images/202411/suit-10.png') },
        { id: 9624, text: '自學日語檢定準備', text2: '就看這一套', price: '2,890', img_url: require('@/assets/images/202411/suit-11.png') },
        { id: 10242, text: '帶你從發音開始學起', text2: '紮好基礎學好法語', price: '2,890', img_url: require('@/assets/images/202411/suit-12.png') }
      ]
    }
  },
  mounted () {
  },
  methods: {
    toTop (n) {
      jump(`${n}`, {
        duration: 500,
        offset: 0
      })
    }
  }
}
</script>
<style lang="scss" scoped>
#November2024 {
    background-image: url('~@/assets/images/202411/mount-background-02.png');
    background-position: center center;
    background-repeat: no-repeat;
  .hover-item {
    .on {
      display: none;
    }
    &:hover {
      .off {
        display: none;
      }
      .on {
        display: block;
      }
    }
  }
  background-color: #FDE6DE;
  .toggle-btn {
    top: 20%;
    left: -50%;
  }
  .fixed-btn {
    top: 50%;
    transform: translateY(-50%);
    right: 0%;
    transition: 0.3s;
  }
  .hidden-btn {
    top: 50%;
    transform: translateY(-50%);
    right: -174px;
    transition: 0.3s;
  }
  .top {
    background-image: url('~@/assets/images/202411/mount-background-01.png');
    background-position: center top 20px;
    background-repeat: no-repeat;
  }
  // .bg-center {
  //   background-image: url('~@/assets/images/202411/mount-background-02.png');
  //   background-position: center center;
  //   background-repeat: no-repeat;
  // }
  .card_outer {
    border: 4px solid #F44601;
    box-shadow: 25px 25px 0px 0px #F44601;
  }
  .text-orange {
    color: #F44601;
  }
  .border-orange {
    border-color: #F44601;
  }
  .boy {
    background-image: url('~@/assets/images/202411/under-block.png');
    background-position: center bottom;
    background-repeat: no-repeat;
    background-size: contain;
  }
  // .yellow-bg-book {
  //   background-color: #FFFCE7;
  // }
  // .purple-border {
  //   border-color: #A3A1DC;
  // }
  // .outer {
  //   position: relative;
  //   width: 100%;
  //   display: block;
  //   &:after {
  //     content: "";
  //     display: block;
  //     padding-Bottom: 100%;
  //   }
  //   .inner {
  //     left: 50%;
  //     top: 50%;
  //     transform: translate(-50%, -50%);
  //   }
  // }
}
</style>
